
const MerchanIcons = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path d="M4.97412 5.8028L4.41829 3.3028H2.81079" stroke={`${color}`} stroke-opacity="0.72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.44245 12.6445L4.97412 5.8028H15.5225C16.0533 5.8028 16.4483 6.29196 16.3375 6.81113L15.0858 12.6445C15.0033 13.0286 14.6641 13.3028 14.2708 13.3028H7.25662C6.86412 13.3028 6.52495 13.0286 6.44245 12.6445Z" stroke={`${color}`} stroke-opacity="0.72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.5542 16.3236C14.3817 16.3236 14.2417 16.4636 14.2433 16.6361C14.2433 16.8086 14.3833 16.9486 14.5558 16.9486C14.7283 16.9486 14.8683 16.8086 14.8683 16.6361C14.8675 16.4636 14.7275 16.3236 14.5542 16.3236" stroke={`${color}`} stroke-opacity="0.72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.38002 16.3236C7.20752 16.3236 7.06752 16.4636 7.06919 16.6361C7.06836 16.8086 7.20836 16.9486 7.38086 16.9486C7.55336 16.9486 7.69336 16.8086 7.69336 16.6361C7.69336 16.4636 7.55336 16.3236 7.38002 16.3236" stroke={`${color}`} stroke-opacity="0.72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default MerchanIcons
